import { useCallback } from 'react';

import useAuth from './useAuth';

export const useTrimWorkspace = () => {
  const { user } = useAuth();

  return useCallback(
    (workspaceName) => {
      let trimmedDownName = workspaceName;

      const org = user.organisations.find((e) =>
        workspaceName.includes(e.name)
      );
      trimmedDownName = org
        ? workspaceName.split(`${org.name} - `)[1] ?? workspaceName
        : workspaceName;

      return trimmedDownName;
    },
    [user?.organisations]
  );
};
